import { Map, MapDataSource } from "@aidkitorg/types/lib/survey";
import React, { useEffect, useState } from "react";

export const useMapFormState = (component?: Map) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')

  const [geographicDataOption, setGeographicDataOption] = useState('point')

  const [addressField, setAddressField] = useState('')
  const [geoJSONUrl, setGeoJSONUrl] = useState('')

  useEffect(() => {
    if (!component) return

    const componentTitle = 'title' in component && component.title
      ? typeof component.title === 'string'
        ? component.title
        : component.title['en']
      : 'Dashboard Component';
    setTitle(componentTitle)
    setDescription(component.description || '')

    if (component.sources.length === 1) {
      const source = component.sources[0]

      switch (source.kind) {
        case 'Applicant Data Source':
          setGeographicDataOption('point')
          setAddressField(source.addressField)
          break;
        case 'URL GeoJSON Source':
          setGeographicDataOption('polygons')
          setGeoJSONUrl(source.url)
          break;
      }
    }
  }, [component])

  const buildMapObject = (): Map => {
    const source = () => {
      switch(geographicDataOption) {
        case 'point': 
          return {
            layerName: 'Address',
            kind: 'Applicant Data Source',
            filter: {
              kind: 'Not',
              clause: {
                kind: 'Never'
              }
            },
            columns: [],
            addressField: addressField
          } as MapDataSource
        case 'polygons':
          return {
            layerName: 'GeoJSON',
            kind: 'URL GeoJSON Source',
            url: geoJSONUrl
          } as MapDataSource
        default: 
          return {
            layerName: 'Address',
            kind: 'Applicant Data Source',
            filter: {
              kind: 'Not',
              clause: {
                kind: 'Never'
              }
            },
            columns: [],
            addressField: addressField
          } as MapDataSource 
      }}

    const map: Map = {
      kind: 'Map',
      sources: [source()],
      title: title,
      description: description
    }

    return map
  }

  return {
    title, setTitle,
    description, setDescription,
    geographicDataOption, setGeographicDataOption,
    addressField, setAddressField,
    geoJSONUrl, setGeoJSONUrl,
    buildMapObject
  }
}